import React, { useCallback, useEffect, useRef, useState } from "react";
import { defaultUserImg } from "../Constants/Images";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { messagesList } from "../Constants";
import {
  faPaperPlane,
  faSpinner,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import {
  clearMessageListAction,
  getMessagesAction,
  sendMessageAction,
} from "../Services/Store/Actions/MessageConversationsAction";
import { useDispatch, useSelector } from "react-redux";
import useAuth from "../Hooks/useAuth";
import { showToast } from "../utils/helpers";
import moment from "moment";

interface ChatMessagesType {
  spaceAuthor: {
    id: string;
    name: string;
    image: string;
  } | null;
  closeChat: Function;
}

const AddChatMessages: React.FC<ChatMessagesType> = ({
  spaceAuthor,
  closeChat,
}) => {
  const dispatch = useDispatch();
  const [isTyping, setIsTyping] = useState(false);

  const { user } = useAuth();
  const containerRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [show, setShowChat] = useState(false);
  const [hideChat, toggleHideChat] = useState(false);

  const [msgSending, setMsgSending] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 0,
    totalMessages: 0,
  });

  const [messagesList, setMessages] = useState([]);
  const { messages } = useSelector((state: any) => state.messages);

  const [data, setData] = useState({
    message: "",
  });

  const onChange = (field: string, value: string) => {
    setData({
      ...data,
      [field]: value,
    });
  };

  const renderMessage = (item: object, index: number) => {
    const itemClass =
      item && item.senderId === user.id
        ? "message-item reponder-message"
        : "message-item";

    const messageUserName =
      item && item.senderId === user.id ? user.name : spaceAuthor.name;

    let messageUserImg = defaultUserImg;
    if (item && item.senderId === user.id && user.image) {
      messageUserImg = user.image;
    } else if (spaceAuthor && spaceAuthor.image) {
      messageUserImg = spaceAuthor.image;
    }

    return (
      <div className={itemClass}>
        <div className="user-img">
          <img src={messageUserImg} alt="" />
        </div>

        <div className="message-content">
          <div className="message-heading">
            <b>{messageUserName},</b>
            <br />{" "}
            <small>
              {item &&
                item.createdAt &&
                moment(item.createdAt).format("MM/DD/YYYY hh:mm a")}
            </small>
          </div>
          <div className="message-text">
            <p>{(item && item.text) || ""}</p>
          </div>
        </div>
      </div>
    );
  };

  const getUserMessages = useCallback(
    (userId: string, page: number = 1) => {
      if (!loading) {
        const params = {
          userId: spaceAuthor && spaceAuthor.id,
          page,
          limit: 30,
        };

        console.log("params :", params);

        setLoading(true);

        getMessagesAction(params, dispatch)
          .then((res) => {
            if (res.type === "success") {
              setPagination(res.data.pagination);
            }
          })
          .catch((err) => {})
          .finally(() => setLoading(false));
      }
    },
    [spaceAuthor]
  );

  const sendMessage = useCallback(() => {
    let isError = false;

    if (data.message === "") {
      isError = true;

      showToast("error", "Please write some word to send message!");
    }

    if (!isError && !msgSending) {
      const params = {
        receiverId: spaceAuthor.id,
        text: data.message,
      };

      setMsgSending(true);

      console.log("send params :", params);

      sendMessageAction(params, dispatch)
        .then((res) => {
          console.log("messageSend", res);

          setData({
            message: "",
          });

          if (res.type === "success") {
          } else {
            showToast("error", res.message);
          }
        })
        .catch((err) => {
          showToast("error", err.message);
        })
        .finally(() => setMsgSending(false));

      console.log("sendMessage:", params);
    }
  }, [spaceAuthor, data, msgSending]);

  useEffect(() => {
    setMessages(messages);
  }, [messages]);

  useEffect(() => {
    console.log("spaceAuthor :", spaceAuthor);

    if (spaceAuthor) {
      getUserMessages(spaceAuthor.id);
    }
  }, [spaceAuthor]);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.scrollTop = container.scrollHeight; // scroll to bottom
    }
  }, [messagesList]); // run when content changes

  useEffect(() => {
    return () => clearMessageListAction(dispatch);
  }, []);

  console.log("messagesList :", messagesList);

  return (
    <div className="front-chat-wrapper ">
      <div className="chat-header">
        <img
          src={
            spaceAuthor && spaceAuthor.image
              ? spaceAuthor.image
              : defaultUserImg
          }
          alt={(spaceAuthor && spaceAuthor.name) || ""}
        />

        <div className="chat-header-title">
          <h3>{spaceAuthor && spaceAuthor.name}</h3>
          <p>Dicuss your queries</p>
        </div>
        <div className="close-btn" onClick={() => closeChat()}>
          <FontAwesomeIcon icon={faTimes} size={55} color="#fff" />
        </div>
      </div>
      <div ref={containerRef} className="message-list-wrapper">
        {messagesList.length > 0 && messagesList.map(renderMessage)}
      </div>

      <div className="chat-form-wrapper">
        <textarea
          name="message"
          placeholder="Write your message"
          onChange={(e) => onChange("message", e.target.value)}
          className="form-control"
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              console.log("Key :", e.key);
              sendMessage();
              e.preventDefault();
            }
          }}
          value={data.message}
        ></textarea>

        {/* <input name="message" type="text" /> */}

        <div className="action-btns">
          <span className="send-message" onClick={() => sendMessage()}>
            {msgSending && (
              <FontAwesomeIcon icon={faSpinner} color="#4A4C56" spin />
            )}
            {!msgSending && (
              <FontAwesomeIcon icon={faPaperPlane} color="#4A4C56" />
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AddChatMessages;
